import { render, staticRenderFns } from "./GoogleFont.vue?vue&type=template&id=2e99931d&"
import script from "./GoogleFont.vue?vue&type=script&lang=js&"
export * from "./GoogleFont.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports